<ng-container *transloco="let t">
  <td iTableTd>
    <span class="font-bold text-gray-500">{{
      amazonInvoice().invoiceDate | date: "shortDate" : undefined : locale()
    }}</span>
  </td>
  <td iTableTd>
    <span class="text-gray-500">{{ amazonInvoice().invoiceId }}</span>
  </td>
  <td iTableTd>
    <span class="text-xs text-gray-500">
      {{ amazonInvoice().fromDate | date: "shortDate" : undefined : locale() }} -
      {{ amazonInvoice().toDate | date: "shortDate" : undefined : locale() }}
    </span>
  </td>
  <td iTableTd>
    <span class="text-gray-500">{{ amazonInvoice().amount | currency: amazonInvoice().currency }}</span>
  </td>
  <td iTableTd>
    <span class="text-gray-500">{{ amazonInvoice().tax | currency: amazonInvoice().currency }}</span>
  </td>
  <td iTableTd>
    @let status = invoiceStatus();
    <IBadge [label]="status.label" variant="soft" [color]="status.color" />
  </td>
  <td iTableTd>
    <span class="text-gray-500">{{ amazonInvoice().dueDate | date: "shortDate" : undefined : locale() }}</span>
  </td>
  <td iTableTd class="text-right">
    <button iButton variant="ghost" size="sm" (click)="downloadInvoice()" [loading]="downloading()">
      <IIcon name="import" />
    </button></td
></ng-container>
